(function( $ ) {
    // the sameHeight functions makes all the selected elements of the same height
    $.fn.setLeadershipHeight = function() {
        let leadershipHeight = $('.js-leadership-get-height').outerHeight();
        $('.js-leadership-set-height').css('height',leadershipHeight);
    };
}( jQuery ));



    $('.js-leadership-set-height').setLeadershipHeight();
    $(window).resize(function(){
        // Do it when the window resizes too
        $('.js-leadership-set-height').setLeadershipHeight();
    });
